import api from '../api';

export const independentTasksService = {
  getAll: async () => {
    const response = await api.get('/independent/tasks');
    return response.data;
  },

  create: async (taskData) => {
    const response = await api.post('/independent/tasks', taskData);
    return response.data;
  },

  update: async (id, taskData) => {
    const response = await api.put(`/independent/tasks/${id}`, taskData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/independent/tasks/${id}`);
    return response.data;
  }
};

export default independentTasksService;
